import { render, staticRenderFns } from "./audioCreating.vue?vue&type=template&id=03b0cd1c&scoped=true&"
import script from "./audioCreating.vue?vue&type=script&lang=ts&"
export * from "./audioCreating.vue?vue&type=script&lang=ts&"
import style0 from "./audioCreating.vue?vue&type=style&index=0&id=03b0cd1c&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "03b0cd1c",
  null
  
)

export default component.exports